(function () {
  function loadKiyoh(section) {
    if (!section || section.dataset.kiyohLoading === 'true') return;
    section.dataset.kiyohLoading = 'true';

    var clusterId = section.dataset.kiyohCluster;
    var endpoint = 'https://broken-credit-e9b2.quincy-f2e.workers.dev/';
    if (clusterId) endpoint += '?clusterId=' + encodeURIComponent(clusterId);

    fetch(endpoint)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        var rating = parseFloat(data.averageRating) || 0;
        var count = parseInt(data.numberReviews, 10) || 0;
        var circlesValue = Math.round((rating / 2) * 10) / 10;

        var scoreEl = section.querySelector('[data-kiyoh-score]');
        var circlesEl = section.querySelector('[data-kiyoh-circles]');
        var countEl = section.querySelector('[data-kiyoh-count]');
        var headingEl = section.querySelector('[data-kiyoh-heading]');

        var isCompact = section.classList.contains('kiyoh-reviews--align-left');
        var scoreText = rating % 1 === 0 ? rating.toFixed(0) : rating.toFixed(1);
        if (scoreEl) scoreEl.textContent = isCompact ? scoreText : scoreText + '/10';
        if (circlesEl) circlesEl.style.setProperty('--rating', circlesValue);
        if (countEl) countEl.textContent = isCompact ? '(' + count + ' reviews)' : count + ' beoordelingen';

        var isProductResponse = Array.isArray(data.locationProduct) || Array.isArray(data.reviews);
        var useProduct = clusterId && isProductResponse && count > 0;

        if (headingEl) {
          var productHeading = section.dataset.kiyohHeadingProduct || '';
          var storeHeading = section.dataset.kiyohHeadingStore || '';
          headingEl.textContent = useProduct ? productHeading : storeHeading;
        }

        var targetUrl = useProduct ? section.dataset.kiyohUrlProduct : section.dataset.kiyohUrlStore;
        if (targetUrl) {
          section.querySelectorAll('[data-kiyoh-link]').forEach(function (link) {
            link.setAttribute('href', targetUrl);
          });
        }

        section.classList.add('kiyoh-reviews--loaded');
      })
      .catch(function () {
        section.dataset.kiyohLoading = 'false';
      });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-kiyoh-section]').forEach(loadKiyoh);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
